export default "__VITE_ASSET__BlLfjJ8P__"